import { Switch, Route } from 'react-router-dom';
import { defaultRoutes } from '@/routers/routes';
import PageNotFound from '@/pages/PageNotFound';

export default function DefaultLayout() {
  return (
    <Switch>
      {defaultRoutes
        .filter((item: any) => !item.isLayout)
        .map((item: any) => (
          <Route
            key={item.path}
            path={item.path}
            component={item.component}
            exact={item.exact}
          />
        ))}
      <Route component={PageNotFound} />
    </Switch>
  );
}
